import React from 'react';

import Event from '../slots/Event';
import Combi from '../slots/Combi';

const Slot = props => {

  const {data, filters, filterView} = props,
        performances = data.performances;

  let performances_arr = [];
  if (filterView == "calendar" && typeof filters !== "undefined" && typeof filters.calendar.selected_dates !== "undefined" ){
    filters.calendar.selected_dates.forEach((selected_date) => {
      if (typeof performances[selected_date] !== 'undefined') {
        performances_arr.push(<Performances data={performances} filterView={filterView} filters={filters} date={selected_date}/> )
      }
    });

  }


  return (
    <>
    { (filter_block == "Events"  &&
      <Event data={data}  />)
    || (filter_block == "Combi"  &&
      <Combi data={data} filterView={filterView}/>)
    }

    </>
  )
}

export default Slot;
